export default __webpack_public_path__ + "static/media/img17.35987aab.jpg";